import {FC} from 'react';

import Button from '@/shared/components/button';

import RegisterCard from '../RegisterCard';
import {LOGIN_CARD} from './consts';

interface AdvantageSectionProps {
  handleSignInWithEmail: () => void;
}

const AdvantageSection: FC<AdvantageSectionProps> = ({
  handleSignInWithEmail,
}) => {
  return (
    <section className="py- flex flex-col items-center gap-4 bg-white px-4 py-14 sm:px-12 sm:py-20">
      <div className="flex flex-col gap-4 sm:flex-row">
        {LOGIN_CARD.map((card) => (
          <RegisterCard
            key={card.title}
            image={card.image}
            title={card.title}
            description={card.description}
          />
        ))}
      </div>
      <Button
        onClick={handleSignInWithEmail}
        variant="primary"
        size="standard"
        className="w-full max-w-96"
      >
        Try Now
      </Button>
    </section>
  );
};

export default AdvantageSection;
